import React from 'react';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { UilTrashAlt, UilClipboard } from '@iconscout/react-unicons';
import { useClipboard } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };
const r300 = { bg: 'red.300', borderColor: 'red.300' };
const r400 = { bg: 'red.400', borderColor: 'red.400' };

const UploadedImage = ({ image, index, images, updateRedux, noCopy }) => {
	const { hasCopied, onCopy } = useClipboard(image, 500);
	const dispatch = useDispatch();

	const removeImage = () => {
		const newImages = [...images];
		newImages.splice(index, 1);
		dispatch(updateRedux(newImages));
	};

	return (
		<Box borderRadius={'4px'} p={2} border={'1px solid black'} position={'relative'}>
			<img src={image} alt="" style={{ maxWidth: '100%', maxHeight: '200px' }} />
			<Flex justifyContent={'flex-start'} position={'absolute'} top={2} right={2}>
				<Flex gap={'8px'}>
					{!noCopy && (
						<IconButton
							onClick={onCopy}
							disabled={hasCopied ? true : false}
							size={'sm'}
							icon={<UilClipboard size={18} color="gray.700" />}
							_hover={y300}
							_active={y400}
							_focus={y400}
						/>
					)}
					<IconButton
						size={'sm'}
						icon={<UilTrashAlt />}
						onClick={removeImage}
						_hover={r300}
						_active={r400}
						_focus={r400}
					/>
				</Flex>
			</Flex>
		</Box>
	);
};

export default UploadedImage;
